import type { ReactNode } from "react";
import { Button } from "@themes/pollinator/ui/Button";
import { Type } from "@themes/pollinator/ui/Type";
import { ProgramMeetingRoleBadge } from "@platform/features/programScheduling";
import type { MeetingRole } from "@platform/types/platform.types";

export type Props = {
  /** The cohort meeting message slot (typically <SchedulingCohortMessageContainer />). */
  message: ReactNode;
  /** When true, shows the primary "Join Upcoming Meeting" button. */
  hasMeeting: boolean;
  /** The user's role in the visible circle's current meeting. When null, the role row is hidden. */
  role: MeetingRole | null;
  onScheduleClick: () => void;
  onCohortClick: () => void;
  onJoinClick: () => void;
};

export function CohortDashboardBanner({
  message,
  hasMeeting,
  role,
  onScheduleClick,
  onCohortClick,
  onJoinClick,
}: Props) {
  return (
    <div className="flex flex-col gap-4 pb-8 border-b border-brand-800 w-full">
      {message}
      {role && (
        <div className="flex flex-row gap-0.5 items-center">
          <Type variant="body2">Your role this week:</Type>
          <ProgramMeetingRoleBadge role={role} badgeClassName="ml-1" />
        </div>
      )}
      <div className="flex flex-col gap-2 md:flex-row md:gap-3">
        <Button
          variant="secondary"
          onClick={onScheduleClick}
          className="w-full md:w-fit"
          data-testid="cohort-banner-schedule"
        >
          Schedule
        </Button>
        <Button
          variant="secondary"
          onClick={onCohortClick}
          className="w-full md:w-fit"
          data-testid="cohort-banner-cohort"
        >
          Cohort
        </Button>
        {hasMeeting && (
          <Button
            variant="primary"
            onClick={onJoinClick}
            className="w-full md:w-fit"
            data-testid="cohort-banner-join"
          >
            Join Upcoming Meeting
          </Button>
        )}
      </div>
    </div>
  );
}

export default CohortDashboardBanner;
